import axios from 'axios';

const instance = axios.create({
  baseURL: `http://vueapp.vue.gov.py/servicios_consultorias_backend/api/`,
  headers: { 'Content-Type': 'application/json' }
});

export default instance;
